module.exports = __webpack_public_path__ + "img/6535.9978c171.jpg";